import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import _ from "lodash";

import { getInvitados } from "services/invitacionesService";
import { Container, Button, Row, Col, FormGroup, Table } from "reactstrap";
import { getEventosVigentes } from "services/eventoService";
import Select from "react-select";

const Invitados = (props) => {
  const { user } = props;

  const [evento, setEvento] = useState(null);
  const [selectedEvento, setSelectedEvento] = useState(null);
  const [eventos, setEventos] = useState([]);
  const [mounted, setMounted] = useState(false);
  const [invitados, setInvitados] = useState([]);
  const [totalInvitados, setTotalInvitados] = useState(0);
  const [totalAcreditados, setTotalAcreditados] = useState(0);
  const [totalAsistieron, setTotalAsistieron] = useState(0);

  const fetchData = async (evento) => {
    let lista = [];
    const response = await getInvitados(evento);
    let totalInvitados = 0;
    let totalAcreditados = 0;
    let totalAsistieron = 0;
    response.map((invitado) => {
      lista.push({
        nombre: invitado.confirmo ? invitado.apellido + " " + invitado.nombre : invitado.contacto,
        dni: invitado.dni,
        telefono: invitado.telefono,
        email: invitado.email,
        acreditado: invitado.confirmo ? "Si" : "No",
        ingreso: invitado.asistio ? "Sí" : "No",
        invito: invitado.user.nombre + " " + invitado.user.apellido,
      });
      totalInvitados++;
      if (invitado.confirmo) totalAcreditados++;
      if (invitado.asistio) totalAsistieron++;
      setTotalInvitados(totalInvitados);
      setTotalAcreditados(totalAcreditados);
      setTotalAsistieron(totalAsistieron);
    });
    setInvitados(lista);
    setMounted(true);
  };

  const fetchEventos = async () => {
    const response = await getEventosVigentes();
    setEventos(response);
    setMounted(true);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    // if (!mounted) fetchData();
    if (!mounted) fetchEventos();
  }, []);

  const handleSelectEvento = (selectedOption, input) => {
    const value = selectedOption.value;
    setSelectedEvento(selectedOption);
    setEvento(value);
    fetchData(value);
  };

  const handleXLS = (acreditados, csv = false) => {
    let lista = [];
    // if (acreditados) lista = invitados.filter((item) => item.acreditado === "Si" && item.invito !== "Daniella Levine");
    if (acreditados) lista = invitados.filter((item) => item.acreditado === "Si");
    else lista = invitados;

    if (csv) lista = lista.filter((item) => !item.email.toUpperCase().includes("REMAX.COM.AR"));
    lista.sort((a, b) => {
      const nameA = a.nombre.toUpperCase(); // ignore upper and lowercase
      const nameB = b.nombre.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });

    const worksheet = XLSX.utils.json_to_sheet(lista);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Invitados");
    XLSX.utils.sheet_add_aoa(
      worksheet,
      [["Nombre", "DNI", "Teléfono", "e-mail", "Acreditado", "Ingresó", "Invitado Por"]],
      { origin: "A1" }
    );

    // let objectMaxLength = [];
    // const [startLetter, endLetter] = worksheet["!ref"]?.replace(/\d/, "").split(":");
    // const ranges = _.range(startLetter.charCodeAt(0), endLetter.charCodeAt(0) + 1);
    // ranges.forEach((c) => {
    //   const cell = String.fromCharCode(c);
    //   const cellLength = worksheet[`${cell}1`].v.length + 1;
    //   objectMaxLength.push({ wch: cellLength });
    // });
    // console.log(objectMaxLength);
    // worksheet["!cols"] = objectMaxLength;
    // worksheet["!cols"] = objectMaxLength;
    worksheet["!cols"] = [{ wch: 50 }, { wch: 10 }, { wch: 15 }, { wch: 30 }, { wch: 10 }, { wch: 10 }, { wch: 40 }];

    // if (!worksheet["!cols"]) worksheet["!cols"] = [];
    // let max_width = invitados.reduce((w, r) => Math.max(w, r.nombre.length), 5);
    // worksheet["!cols"][2] = [{ wch: max_width }];
    // max_width = invitados.reduce((w, r) => Math.max(w, r.dni.length), 5);
    // worksheet["!cols"][2] = [{ wch: max_width }];
    // max_width = invitados.reduce((w, r) => Math.max(w, r.telefono.length), 5);
    // worksheet["!cols"][3] = [{ wch: max_width }];
    // max_width = invitados.reduce((w, r) => Math.max(w, r.email.length), 5);
    // worksheet["!cols"][4] = [{ wch: max_width }];
    // max_width = invitados.reduce((w, r) => Math.max(w, r.confirmo.length), 5);
    // worksheet["!cols"][5] = [{ wch: max_width }];
    // max_width = invitados.reduce((w, r) => Math.max(w, r.invito.length), 5);
    // worksheet["!cols"][6] = [{ wch: max_width }];
    if (!csv) XLSX.writeFile(workbook, "invitados.xlsx", { compression: true });
    else XLSX.writeFile(workbook, "invitados.csv", { bookType: "csv", FS: "," });
  };

  return (
    <>
      <Container className="wrapper">
        <h3 className="mt-4 mb-2">Invitados</h3>
        <Row className="justify-content-center mt-3">
          <Col md="6" sm="6">
            <FormGroup>
              <Select
                isSearchable={false}
                placeholder="Seleccione Evento"
                classNamePrefix="react-select"
                name="selectedEvento"
                value={selectedEvento}
                onChange={(selectedOption, input) => handleSelectEvento(selectedOption, input)}
                options={eventos}
              />
              {/* {errors["profile"] ? (
                  <div className="form-control-feedback text-danger ml-3">{errors["profile"]}</div>
                ) : (
                  ""
                )} */}
            </FormGroup>
          </Col>
        </Row>

        {evento && (
          <>
            <Row className="justify-content-center mt-3">
              <Button
                disabled={invitados.length === 0}
                className="btn-round mr-1 blue"
                color="success"
                type="button"
                onClick={() => handleXLS(true)}
              >
                EXCEL Acreditados
              </Button>
              <Button
                disabled={invitados.length === 0}
                className="btn-round mr-1 blue"
                color="success"
                type="button"
                onClick={() => handleXLS(true, true)}
              >
                CSV Para Sorteo
              </Button>
              <Button
                disabled={invitados.length === 0}
                className="btn-round mr-1 blue"
                color="success"
                type="button"
                onClick={() => handleXLS(false)}
              >
                Todos
              </Button>
            </Row>
            <Row className="justify-content-center mt-5">
              <Col className="sm-4 md-4 d-flex justify-content-center">
                <h6>Invitados: {totalInvitados}</h6>
              </Col>
              <Col className="sm-4 md-4 d-flex justify-content-center">
                <h6>Acreditados: {totalAcreditados}</h6>
              </Col>
              <Col className="sm-4 md-4 d-flex justify-content-center">
                <h6>Asistieron: {totalAsistieron}</h6>
              </Col>
            </Row>
            <Table hover responsive striped className="mt-1">
              <thead>
                <tr>
                  <th style={{ width: "20%" }}>Nombre</th>
                  <th style={{ width: "20%" }}>DNI</th>
                  <th style={{ width: "10%" }}>Teléfono</th>
                  <th style={{ width: "10%" }}>Mail</th>
                  <th style={{ width: "10%", textAlign: "center" }}>Acreditado</th>
                  <th style={{ width: "10%", textAlign: "center" }}>Asistió</th>
                  <th style={{ width: "20%" }}>Invitado Por</th>
                </tr>
              </thead>
              <tbody>
                {invitados.map((invitado) => (
                  <tr key={Math.random()}>
                    <td>{invitado.nombre}</td>
                    <td>{invitado.dni}</td>
                    <td>{invitado.telefono}</td>
                    <td>{invitado.email}</td>
                    <td style={{ textAlign: "center" }}>{invitado.acreditado}</td>
                    <td style={{ textAlign: "center" }}>{invitado.ingreso}</td>
                    <td>{invitado.invito}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </Container>
    </>
  );
};

export default Invitados;
